export const matchesShiftQuestionKey = (event: KeyboardEvent): boolean => {
  if (!event.shiftKey || event.ctrlKey || event.metaKey || event.altKey) {
    return false;
  }

  return event.code === 'Slash' || event.key === '?' || event.key === '/';
};

export const isTypingTarget = (target: EventTarget | null): boolean => {
  const element = target as HTMLElement;
  return element.tagName === 'INPUT'
    || element.tagName === 'TEXTAREA'
    || element.isContentEditable;
};
